export const handleCheckboxChange = (e, form, fieldName, personalAddress, path = null, track = null, events = null) => {
  const checked = e.target.checked;
  track(events.formBuilder.checkboxInteraction(path, fieldName, checked));
  form.setFieldValue(fieldName, checked);

  if (fieldName === 'isPersonalAddress') {
    if (checked) {
      copyAddressFromPersonal(form, personalAddress);
    } else {
      clearBusinessAddressFields(form);
      setTimeout(() => {
        form.setTouched({ ...form.touched, buildingType: false });
        form.setTouched({ province: false });
        form.validateField('buildingType');
      }, 0);
    }
  }
};

export const copyAddressFromPersonal = (form, personalAddress) => {
  form.setFieldValue('buildingType', personalAddress?.buildingType || '');

  setTimeout(() => {
    form.setTouched({ ...form.touched, buildingType: true });
    form.validateField('buildingType');
  }, 0);

  switch (personalAddress?.buildingType) {
    case 'House':
      setHouseFields(form, personalAddress);
      break;
    case 'Flat/Apartment':
      setFlatApartmentFields(form, personalAddress);
      break;
    case 'Townhouse/Security Estate':
      setTownhouseFields(form, personalAddress);
      break;
    case 'Office':
      setOfficeFields(form, personalAddress);
      break;
  }

  setCommonFields(form, personalAddress);
};

export const clearBusinessAddressFields = (form) => {
  const fieldsToClear = [
    'buildingType',
    'unitNumber',
    'street',
    'building',
    'flatUnitFloor',
    'address',
    'estateName',
    'buildingOfficeParkName',
    'unitSuiteNumber',
    'suburb',
    'postalCode',
    'province',
    'houseUnitNumber',
    'houseStreet',
    'city'
  ];

  fieldsToClear.forEach(field => form.setFieldValue(field, ''));
};

export const setHouseFields = (form, personalAddress) => {
  form.setFieldValue('houseUnitNumber', personalAddress?.unitNumber || '');
  form.setFieldValue('houseStreet', personalAddress?.street || '');
  form.setFieldValue('building', '');
  form.setFieldValue('flatUnitFloor', '');
  form.setFieldValue('address', '');
  form.setFieldValue('estateName', '');
  form.setFieldValue('buildingOfficeParkName', '');
  form.setFieldValue('unitSuiteNumber', '');
};

export const setFlatApartmentFields = (form, personalAddress) => {
  form.setFieldValue('flatBuilding', personalAddress?.building || '');
  form.setFieldValue('flatUnitFloor', personalAddress?.flatUnitFloor || '');
  form.setFieldValue('flatStreet', personalAddress?.street || '');
  form.setFieldValue('flatUnitNumber', personalAddress?.unitNumber);
  form.setFieldValue('street', '');
  form.setFieldValue('estateName', '');
  form.setFieldValue('buildingOfficeParkName', '');
  form.setFieldValue('unitSuiteNumber', '');
};

export const setTownhouseFields = (form, personalAddress) => {
  form.setFieldValue('townBuilding', personalAddress?.building || '');
  form.setFieldValue('townUnitNumber', personalAddress?.unitNumber || '');
  form.setFieldValue('townStreet', personalAddress?.street || '');
  form.setFieldValue('building', '');
  form.setFieldValue('flatUnitFloor', '');
  form.setFieldValue('address', '');
  form.setFieldValue('buildingOfficeParkName', '');
  form.setFieldValue('unitSuiteNumber', '');
};

export const setOfficeFields = (form, personalAddress) => {
  form.setFieldValue('officeBuilding', personalAddress?.building || '');
  form.setFieldValue('officeUnitNumber', personalAddress?.unitNumber || '');
  form.setFieldValue('officeStreet', personalAddress?.street || '');
  form.setFieldValue('unitNumber', '');
  form.setFieldValue('street', '');
  form.setFieldValue('building', '');
  form.setFieldValue('flatUnitFloor', '');
  form.setFieldValue('estateName', '');
};

export const setCommonFields = (form, personalAddress) => {
  form.setFieldValue('suburb', personalAddress?.suburb || '');
  form.setFieldValue('postalCode', personalAddress?.postalCode || '');
  form.setFieldValue('city', personalAddress?.city || '');
  form.setFieldValue('province', personalAddress?.province || '');
};
